import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/app';
import { adminBrand } from './shared/config/env';
import { initialThemeMode } from './shared/theme/theme-provider';
// Taban katman KİTTEN gelir; panel kendi global CSS'ini YAZMAZ.
import '@icebreaker/ui/base.css';

/**
 * Giriş noktası.
 *
 * TEMA İLK BOYAMADAN ÖNCE: karanlık tema flaşını engelleyen kod paketin
 * İÇİNDEDİR — web'de bu `<head>` içinde satır içi bir script'ti (SSR
 * gerektiriyordu). Panelde SSR yok, bu yüzden inline script de yok ve CSP
 * `script-src` gevşetilmeden aynı sonuç alınır.
 *
 * Sekme başlığı marka katmanından yazılır; `index.html`deki değer yalnız ilk
 * karedeki etikettir.
 */
document.documentElement.dataset.theme = initialThemeMode();
document.title = adminBrand.name;

const container = document.getElementById('root');
if (!container) throw new Error('root container missing');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
